export { createTopNavigator, TopNavigator } from './TopNavigator';
